import React from "react";
import {PresentUponHoverBase, PresentUponHoverBlockCommon} from "./PresentUponHoverBlockCommon";
import styled from "@emotion/styled";
import hoverDriverSvg from "../assets/hover-driver-svg.svg";
import hoverStopsSvg from "../assets/hover-stops-svg.svg";
import {getMaxHeightOfOptionOrSelection} from "../../v2/utils/manifest-card-configuration.utils";
import {Controller, useFormContext} from "react-hook-form";
import {IManifestCardConfigurationsV2} from "../../v2/types/manifest-card-configurations.type";
import {HOVERS_ON_DRIVERS_OPTIONS, HOVERS_ON_STOPS_OPTIONS} from "../../v2/constants/constants";

const defaultHeightOfSearchContainer = 48;
const defaultHeightOfFooter = 36;
const maxHeightOfDropdownDriver = 400;
const maxHeightOfDropdownStops = 322;
const aboveAndBelowPaddingSelectionBox = 6;

const hoverOnDriverProps: PresentUponHoverBase = {
  dataTestId: "hover-on-driver-block",
  mainImg: hoverDriverSvg,
  mainTitle: "1. Hover on Driver Information",
  subTitle: "Select up to six data points from the drop-down",
  reArrangeTitle: "Rearrange the order in which you want the information presented by dragging the handle",
  totalOptions: HOVERS_ON_DRIVERS_OPTIONS,
  exceedMaxSelection: 6,
  maxHeightOfOptionOrSelection: getMaxHeightOfOptionOrSelection(
    maxHeightOfDropdownDriver,
    defaultHeightOfSearchContainer,
    defaultHeightOfFooter,
    aboveAndBelowPaddingSelectionBox
  )
};

const hoverOnStopProps: PresentUponHoverBase = {
  dataTestId: "hover-on-stop-block",
  mainImg: hoverStopsSvg,
  mainTitle: "2. Hover on Stop Information",
  subTitle: "Select up to ten data points from the drop-down",
  reArrangeTitle: "Rearrange the order in which you want the information presented by dragging the handle",
  totalOptions: HOVERS_ON_STOPS_OPTIONS,
  exceedMaxSelection: 10,
  maxHeightOfOptionOrSelection: getMaxHeightOfOptionOrSelection(
    maxHeightOfDropdownStops,
    defaultHeightOfSearchContainer,
    defaultHeightOfFooter,
    aboveAndBelowPaddingSelectionBox
  )
};

const PresentUponHoverForm = () => {
  const {control} = useFormContext<IManifestCardConfigurationsV2>();

  return (
    <HoverFormContainer>
      <Controller
        control={control}
        name={"hoverDriverConfig"}
        render={({field: {onChange, value}}) => (
          <PresentUponHoverBlockCommon {...hoverOnDriverProps} onFieldChange={onChange} fieldValue={value} />
        )}
      />
      <Controller
        control={control}
        name={"hoverStopsConfig"}
        render={({field: {onChange, value}}) => (
          <PresentUponHoverBlockCommon {...hoverOnStopProps} onFieldChange={onChange} fieldValue={value} />
        )}
      />
    </HoverFormContainer>
  );
};

export default PresentUponHoverForm;

const HoverFormContainer = styled.div`
  height: fit-content;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 50px;
`;
